import type { HTMLProps } from 'react';
import type { ModalDialogProps } from '../../../features/modals/types';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { cn } from '../../../utils/common-utils';

type ModalsLayoutProps = HTMLProps<HTMLDivElement> &
  Pick<ModalDialogProps, 'closeModal' | 'title' | 'description'> & {
    classNameModal?: HTMLProps<HTMLDivElement>['className'];
  };

const ModalsLayout = ({
  children,
  className,
  classNameModal,
  closeModal,
  description,
  title,
  ...props
}: ModalsLayoutProps): JSX.Element => {
  return (
    <div
      className={cn(
        'fixed left-0 top-0 z-50 flex h-screen w-screen items-center justify-center overflow-hidden bg-black/40 backdrop-blur-sm',
      )}
      onClick={closeModal}
      {...props}
    >
      <div
        className={cn(
          'absolute flex flex-col items-center justify-start rounded-lg bg-white p-3.5',
          classNameModal,
        )}
        aria-hidden="true"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          className={cn('flex w-full items-center justify-between gap-5 px-2')}
        >
          <div className={'flex flex-col'}>
            <span className={'font-semibold'}>{title}</span>
            <p className={'description my-1'}>{description}</p>
          </div>

          <XMarkIcon
            onClick={closeModal}
            className={
              'h-6 w-6 cursor-pointer rounded fill-red p-1 hover:bg-light-blue'
            }
          />
        </div>

        <hr className={cn('mb-2 w-full opacity-10', className)} />
        {children}
      </div>
    </div>
  );
};

export default ModalsLayout;
